export default {
  fieldNames: {
    operationalAreaSelected: 'Operational Area',
    equipmentGroupSelected: 'Group Type',
    groupReferenceSelected: 'Reference Group',
    equipmentReferenceSelected: 'Equipment Reference',
    componentCodeSelected: 'Component code',
    installedQuantity: 'Installed Quantity',
  },
  group: "Group",
  equipment: "Equipment",
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/cataloger/createNewMaterials/Stages/equipment-group-APL.js